import { FieldMergeFunction, TypePolicies } from '@apollo/client';

const mergePriceRange: FieldMergeFunction = (existing, incoming, { mergeObjects }) => {
    if (!incoming) return existing;
    return existing ? mergeObjects(existing, incoming) : incoming;
};

const mergeOptionValues: FieldMergeFunction = (existing, incoming, { mergeObjects, readField }) => {
    if (!existing || !incoming) return incoming ?? existing;
    const previous = new Map(existing.map((value) => [readField('value_index', value), value]));
    return incoming.map((value) => {
        const match = previous.get(readField('value_index', value));
        return match ? mergeObjects(match, value) : value;
    });
};

/**
 * Prefer complete incoming product/price fields so partial client refetches
 * do not wipe SSR-hydrated price_range (avoids Apollo merge warnings on PDP).
 */
export const apolloTypePolicies: TypePolicies = {
    PriceRange: {
        merge: true,
    },
    ProductPrice: {
        keyFields: false,
        merge: true,
    },
    SimpleProduct: {
        fields: {
            price_range: { merge: mergePriceRange },
        },
    },
    ConfigurableProduct: {
        fields: {
            price_range: { merge: mergePriceRange },
        },
    },
    BundleProduct: {
        fields: {
            price_range: { merge: mergePriceRange },
        },
    },
    ConfigurableProductOptions: {
        fields: {
            values: { merge: mergeOptionValues },
        },
    },
    Products: {
        fields: {
            items: {
                merge(existing, incoming) {
                    return incoming ?? existing;
                },
            },
        },
    },
    // Neither type is normalisable (not every query selects `id`), so without these
    // the second query to write the field replaces the first one's data instead of
    // merging - the SSR cache reaches the browser incomplete and the route refetches.
    CategoryTree: {
        merge: true,
    },
    StoreConfig: {
        merge: true,
    },
    Query: {
        fields: {
            category: { merge: true },
            storeConfig: { merge: true },
        },
    },
};
